var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { LucidSdkContext } from './LucidSdkContext';
export const useLucidSdk = () => {
    _react_refresh_temp_1();
    const lucidSdkValue = useContext(LucidSdkContext);
    if (!lucidSdkValue) {
        throw new Error('LucidSDK context not available!');
    }
    return lucidSdkValue;
};
_react_refresh_temp_1(useLucidSdk, "9Wu4I8pHDAZUXkTbDDHmSdJBYls=");
